
import React from 'react'
import SubscribeEmaillistTable from './Components/SubscribeEmaillistTable'
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AddItemBtn from 'Common/Custom/AddItemBtn';


const SubscribeEmaillist = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Member List</HeadingOne>
          <AddItemBtn url="member-email-add" title="Create Member" />

        </>
      }>

      <div className="col-12">
        <SubscribeEmaillistTable />
      </div>
    </PageBody>
  );
};

export default SubscribeEmaillist;
